$(document).ready(function ($d) {
  var windowLocation = theme.windowUrl;
  let diamond_loading = true;
  var server_closure = theme.server_url;
  // variable to check if reset button clicked
  let isResetButtonClicked = false;
  // Add a response interceptor
  axios.interceptors.response.use(
    function (response) {
      $(".loader,.loader-2").hide();
      $("#diamond-count,#diamond-total-count").show();
      diamond_loading = true;
      isResetButtonClicked = false;
      return response;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  var diamond_count = 0;
  var total_diamond_count = 0;
  // compare diamond certificates
  var compare_diamond =
    JSON.parse(sessionStorage.getItem("compareCertificatesList")) || [];

  function diamond_listing_html(diamond) {
    var diamond_value = diamond.vaultDiscount === "True";
    let diamond_image = diamond?.image_url;
    let priceHtml = "";
    var currency_symbol = theme.country_currency_symbol;
    var currency_conversion_rate = 1;
    switch (theme.country_iso_code) {
      case "GB":
        currency_conversion_rate = 0.81;
        break;
      case "CA":
        currency_conversion_rate = 1.37;
        break;
      case "AU":
        currency_conversion_rate = 1.54;
        break;
      default:
    }
    let diamond_compare_price = parseInt(
      diamond?.total_sales_price * currency_conversion_rate
    );
    let diamond_price = parseInt(
      diamond?.total_discounted_sales_price * currency_conversion_rate
    );
    if (diamond.discount_perc) {
      let percentage_off = `${currency_symbol}${
        diamond_compare_price - diamond_price
      } OFF`;
      // if (diamond?.size > 1.99) {
      //   diamond_price = parseInt(
      //     diamond_price - 250 * currency_conversion_rate
      //   );
      //   percentage_off = `${currency_symbol}${
      //     250 * currency_conversion_rate
      //   } OFF + ${diamond?.discount_perc}% OFF`;
      // }
      priceHtml += `<div>
                  <span>${currency_symbol}${diamond_price.toLocaleString(
        "en-US"
      )}</span>
                  <span>${currency_symbol}${diamond_compare_price.toLocaleString(
        "en-US"
      )}</span>
        <span>(${percentage_off})</span>
      </div>`;
    } else {
      priceHtml += `<span class="main-price">${currency_symbol}${diamond_compare_price.toLocaleString(
        "en-US"
      )}</span>`;
    }

    return `<div class="diamond-list no-pair-diamond ${
      diamond_value ? "featured-diamond-wrapper" : ""
    }" data-diamond-json='${JSON.stringify(diamond)}'>
                <div class="diamond-compare ${
                  compare_diamond.indexOf(diamond?.cert_num) > -1
                    ? "active"
                    : ""
                }"><div><span></span></div></div>
                <div class="diamond-image-wrapper ${
                  diamond_value ? "featured-diamond" : ""
                }">
                <a href="${theme.diamond_product_url}?sku=${diamond?.cert_num}">
                  ${diamond_value ? "<p>Featured deal</p>" : ""}
                  <div class="diamond-image">
                    <img src="${diamond_image}"/>
                  </div>
                  </a>
                </div>
                
                <div class="medium-up--hide diamond-mobile-info">
                <a href="${theme.diamond_product_url}?sku=${diamond?.cert_num}">
                  <p>${diamond?.diamond_name}</p>
                  <p class="extra-info">${
                    diamond?.cut
                  } / ${diamond?.color} / ${diamond?.clarity} </p>
                  ${
                    diamond?.QuickShip == "Y"
                      ? "<p class='extra-quickship'>Quick Ship <span></span></p>"
                      : ""
                  }
                  <div class="extra-price-html diamond-price">${priceHtml}</div>
                  </a>
                </div>
                <div class="small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.shape}</a></div>
                <div class="small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.size}</a></div>
                <div class="small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.color}</a></div>
                <div class="small--hide intensity-wrapper"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.color_intensity ? diamond?.color_intensity : ""}</a></div>
                <div class="small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.clarity}</a></div>
                <div class="small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.cut}</a></div>
                <div class="small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.lab}</a></div>
                <div class="additional-field small--hide">
                <a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.polish}</a></div>
                <div class="additional-field small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.symmetry}</a></div>
                <div class="additional-field small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.fluor_intensity}</a></div>
                <div class="additional-field small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.ratio}</a></div>
                <div class="additional-field small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.table_percent}</a></div>
                <div class="additional-field small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.depth_percent}</a></div>
                <div class="diamond-price small--hide">
                <a href="${theme.diamond_product_url}?sku=${diamond?.cert_num}">
                  ${priceHtml}
                  </a>
                </div>
                <div class="arrow-wrapper">
                  <a href="${
                    theme.diamond_product_url
                  }?sku=${diamond?.cert_num}">               
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" viewBox="0 0 16.67 25.761">
                    <path id="Union_33" data-name="Union 33" d="M11.931,13.935l-.7.821.7-.821L0,0,11.931,13.935,23.862,0,11.931,13.935l.7.821Z" transform="translate(0.813 24.811) rotate(-90)" fill="none" stroke="#1c3348" stroke-width="2.5"/>
                  </svg>
                  </a>
                </div>
                </div>
              `;
  }

  function updateDiamondCount(diamond_count, totalDiamond) {
    total_diamond_count = parseInt(totalDiamond);
    $("#diamond-count,.diamond__all-diamond-tab span").text(
      total_diamond_count.toLocaleString("en-US")
    );
  }

  function loadDoc(filterList, freshLoad) {
    if (freshLoad) {
      $(".diamond-body").html("");
      $(".diamonds-list .loader,.loader-2").show();
      $("#diamond-count,#diamond-total-count").hide();
      diamond_count = 0;
      filterList[9].page = 1;
    }
    var jsonData = { filter: filterList };
    console.log(jsonData, filterList[8], page_count);
    // var c1 = performance.now();
    var endPoint = `${server_closure}/fetchdirectdiamond/`;
    if (windowLocation.indexOf("color-diamonds") > -1) {
      endPoint = `${server_closure}/fetchcolordiamond/`;
    }
    axios
      .post(`${endPoint}`, jsonData)
      .then((res) => {
        $("#filter__shape").removeClass("disabled");
        var diamonds = res.data.data.liveDiamondData.diamond;
        var all_available_diamond_count =
          res.data.data.liveDiamondData.originalCount;
        $("#diamond-total-count span").text(
          all_available_diamond_count.toLocaleString("en-US")
        );
        diamond_count += diamonds.length;
        updateDiamondCount(
          diamond_count,
          res.data.data.liveDiamondData.dataCount
        );
        console.log(page_count, diamonds);
        var diamondsRenderList = "";
        diamonds.map((diamond) => {
          diamondsRenderList += diamond_listing_html(diamond);
        });
        if (freshLoad) {
          if (diamond_count) {
            $(".diamond-body").html(diamondsRenderList);
          } else {
            $(".diamond-body").html(
              `<p class="empty-diamond">No Diamonds Found.</p>`
            );
          }
        } else {
          $(".diamond-body").append(diamondsRenderList);
        }
        filterArray[9].page = page_count + 1;
        page_count += 1;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  let shapes = [];

  // Diamond filter array variables
  let allPageCount = 100;
  let cuts = [1, 2, 3];
  let colors = [6, 7, 8];
  let claritys = [4, 5, 6, 7, 8];
  var polish = [0, 1, 2, 3];
  var symmetrys = [0, 1, 2, 3];
  var color_intensity = [];
  let price = "100,700000";
  let carat = "1.5,20";
  var page_count = 1;
  let orderBy = "Price";
  let sortBy = "ASC";
  let lwratio = "0.9,2.75";
  var fluorescences = [0, 1, 2, 3];
  let sku = "";
  let table = "40,90";
  let depth = "40,90";
  let type = "";
  let diamond_type = "lab";
  let cert_num = "";
  let quick_ship_diamonds = "N";
  let Appointment = "";
  let VaultDiscount = "No";
  let reports = "";
  let country = theme.country_iso_code;
  if (windowLocation.indexOf("color-diamonds") > -1) {
    colors = [];
    cuts = [0, 1, 2, 3];
    claritys = [0, 1, 2, 3, 4, 5, 6, 7, 8];
  }
  if (windowLocation.indexOf("clarity-plus-diamonds") > -1) {
    cuts = [2, 3];
    colors = [7, 8];
    claritys = [7, 8];
  }
  if (windowLocation.indexOf("lab-grown-diamonds") > -1) {
    carat = "1.5,20";
  }
  if (windowLocation.indexOf("natural-diamonds") > -1) {
    diamond_type = "natural";
    cuts = [0, 1, 2, 3];
    colors = [1, 2, 3, 4, 5, 6, 7, 8];
    claritys = [2, 3, 4, 5, 6, 7, 8];
    carat = "0.3,20";
  }
  if (windowLocation.indexOf(theme.featured_diamond_handle) > -1) {
    VaultDiscount = "Yes";
    // quick_ship_diamonds = "Y";
    // $(".diamond__quick-shop-tab,.mm-filter-footer").hide();
    $(".diamond__featured-deal").addClass("quick-active");
  }

  var filterArray;

  function default_diamond_filter() {
    filterArray = [
      { shapes },
      { cuts },
      { colors },
      { claritys },
      { labs: [] },
      { polish },
      { symmetrys },
      { price },
      { carat },
      { page: page_count },
      { orderBy },
      { sortBy },
      { lwratio },
      { fluorescences },
      { sku },
      { table },
      { depth },
      { type },
      { diamond_type },
      { cert_num },
      { quick_ship_diamonds },
      { Appointment },
      { VaultDiscount },
      { reports },
      { country },
      { color_intensity },
    ];
  }

  // Show only selected Ring shape option in diamond list
  let available_shapes = [
    "Round",
    "Princess",
    "Radiant",
    "Pear",
    "Cushion",
    "Asscher",
    "Emerald",
    "Marquise",
    "Oval",
    "Heart",
  ];
  let available_colors = ["Yellow", "Pink", "Blue", "Brown", "Orange", "Green"];
  var ring_settings = JSON.parse(localStorage.getItem("setting-information"));
  function select_default_filter_shape(ring_setting_shape) {
    try {
      var shapeWithHandle = windowLocation.split("/collections/")[1];
      var shapeWithoutHandle = shapeWithHandle.split(
        "-cut-lab-grown-diamonds"
      )[0];
      var shapeCapitalize =
        shapeWithoutHandle.charAt(0).toUpperCase() +
        shapeWithoutHandle.slice(1);
    } catch (e) {
      console.log(e);
    }
    // if url has has shape parameter
    if (
      windowLocation.indexOf("shape=") > -1 &&
      available_shapes.indexOf(windowLocation.split("shape=")[1]) > -1
    ) {
      shapes.push(windowLocation.split("?shape=")[1]);
    } else if (
      windowLocation.indexOf("cut-lab-grown-diamonds") > -1 &&
      available_shapes.indexOf(shapeCapitalize) > -1
    ) {
      shapes.push(shapeCapitalize);
    } else if (ring_setting_shape) {
      shapes.push(ring_setting_shape);
    }
  }

  if (ring_settings) {
    available_shapes = [];
    for (var key in ring_settings.variants) {
      $(".filter-shapes .shape[data-value='" + key + "']").show();
      available_shapes.push(key);
    }
    select_default_filter_shape(ring_settings.shape);
  } else {
    $(".filter-shapes .shape").show();
    select_default_filter_shape();
  }

  /******************** Apply diamond filter settings if user has stored the filter settings ********************/
  if (
    theme.get_local_storage("naturalDiamondFilterSetting") &&
    windowLocation.indexOf("natural-diamonds") > -1
  ) {
    filterArray = JSON.parse(
      theme.get_local_storage("naturalDiamondFilterSetting")
    );
  }
  if (windowLocation.indexOf("lab-grown-diamonds-featured-deals") > -1) {
    if (theme.get_local_storage("labFeaturedFilterSetting")) {
      filterArray = JSON.parse(
        theme.get_local_storage("labFeaturedFilterSetting")
      );
    }
  } else if (
    windowLocation.indexOf("lab-diamonds") > -1 ||
    windowLocation.indexOf("lab-grown-diamonds") > -1
  ) {
    if (theme.get_local_storage("labDiamondFilterSetting")) {
      filterArray = JSON.parse(
        theme.get_local_storage("labDiamondFilterSetting")
      );
    }
  }
  if (windowLocation.indexOf("color-diamonds") > -1) {
    if (theme.get_local_storage("colorLabDiamondFilterSetting")) {
      filterArray = JSON.parse(
        theme.get_local_storage("colorLabDiamondFilterSetting")
      );
    }
  }
  if (filterArray) {
    // Add tick to quickbox if quick_ship_diamonds is enabled in filter
    // if (filterArray[20]["quick_ship_diamonds"] == "Y") {
    //   $(".diamond__quick-shop-tab").addClass("quick-active");
    // }
    // Add tick to featured deals if localstorage has featured data
    if (filterArray[22]["VaultDiscount"] == "Yes") {
      $(".filter-featured-deals .text-box").addClass("active");
      $(".diamond__featured-deal").addClass("quick-active");
    }
    // Add tick to Report if localstorage has Report data
    if (filterArray[4]["labs"]) {
      var labs = filterArray[4]["labs"];
      labs.map(function (lab) {
        $(".filter-report [data-value=" + lab + "]").addClass("active");
        if (lab == "GCAL") {
          $(".diamond__gcal-tab").addClass("active");
        }
      });
    }
    filterArray[23]["country"] = theme.country_iso_code;
  } else {
    default_diamond_filter();
  }
  // override default/stored diamond carat filter on basis of carat in url
  if (windowLocation.indexOf("?carat=") > -1) {
    var currentUrl = window.location.href.split("?")[0];
    var urlParams = new URLSearchParams(window.location.search); // Get the current URL parameters
    var caratName = "carat";
    var caratValue = decodeURIComponent(urlParams.get(caratName));
    if (caratValue == null) {
      return false;
    }
    if (caratValue.indexOf("-") > -1) {
      var carat_split = caratValue.split("-");
      filterArray[8]["carat"] = `${carat_split[0]},${carat_split[1]}`;
    } else {
      filterArray[8]["carat"] = `${caratValue},20`;
    }
  }

  // override default/stored diamond color filter on basis of color in url
  if (
    windowLocation.indexOf("color=") > -1 &&
    available_colors.indexOf(windowLocation.split("color=")[1]) > -1
  ) {
    var color_index =
      parseInt(available_colors.indexOf(windowLocation.split("color=")[1])) + 9;
    colors.push(color_index);
  }

  if (windowLocation.indexOf("carat-lab-grown-diamonds") > -1) {
    //Split url handle to get carat number
    var caratNumberWithAmper = windowLocation.split("/collections/")[1];
    var caratNumber = caratNumberWithAmper.split(
      "-carat-lab-grown-diamonds"
    )[0];
    if (caratNumber.indexOf("-") > -1) {
      var carat_split = caratNumber.split("-");
      filterArray[8]["carat"] = `${carat_split[0]},${carat_split[1]}`;
    } else {
      var caratNumberPlusOne =
        caratNumber == "7" ? "20" : parseInt(caratNumber) + 1;
      filterArray[8]["carat"] = `${caratNumber},${caratNumberPlusOne}`;
    }
  }
  // override default/stored diamond price filter on basis of carat in url
  if (windowLocation.indexOf("?price=") > -1) {
    var priceNumberWithAmper = windowLocation.split("?price=")[1];
    var priceNumber = priceNumberWithAmper.split("&")[0];
    if (priceNumber.indexOf("-") > -1) {
      var price_split = priceNumber.split("-");
      filterArray[7]["price"] = `${price_split[0]},${price_split[1]}`;
    } else {
      filterArray[7]["price"] = `${priceNumber},700000`;
    }
  }
  // override default/stored diamond featured filter on basis of feature in url
  function removeFeatureFlagFromUrl() {
    if (windowLocation.indexOf("?feature=") > -1) {
      var removedFeatureFlag = windowLocation.split("?")[0];
      var removeBaseUrl = removedFeatureFlag.split(".com")[1];
      window.history.replaceState({ path: removeBaseUrl }, "", removeBaseUrl);
    }
  }
  if (windowLocation.indexOf("?feature=") > -1) {
    var featured_diamond_flag = windowLocation.split("?feature=")[1];
    if (featured_diamond_flag.indexOf("true") > -1) {
      filterArray[22]["VaultDiscount"] = "Yes";
      $(".filter-featured-deals .text-box").addClass("active");
      $(".diamond__featured-deal").addClass("quick-active");
    }
  }
  // override default/stored diamond lab filter on basis of feature in url
  if (windowLocation.indexOf("?report=") > -1) {
    var gcal_diamond_flag = windowLocation.split("?report=")[1];
    if (gcal_diamond_flag.indexOf("GCAL") > -1) {
      filterArray[4].labs.push("GCAL");
      $(".diamond__gcal-tab").addClass("active");
      $(".filter-report [data-value='GCAL']").addClass("active");
    }
  }
  // override default/stored diamond shape filter on basis of shape in url
  if (shapes.length) {
    filterArray[0]["shapes"] = shapes;
  }
  // Add tick to shapes if localstorage has shapes
  if (filterArray[0]["shapes"].length) {
    filterArray[0]["shapes"].map(function (shape) {
      $(".filter-shapes [data-value='" + shape + "']").addClass("active");
    });
  }
  // Add tick to color if localstorage has color
  if (filterArray[2]["colors"].length) {
    $('.filter__diamond-intensity').show();
    filterArray[2]["colors"].map(function (color) {
      $(".filter-diamond-colors [data-value=" + color + "]").addClass("active");
      $(".filter-diamond-intensity").attr("data-color", color);
    });
  }else{
    $('.filter__diamond-intensity').hide();
  }
  // Add tick to color_intensity if localstorage has color_intensity
  try {
    if (filterArray[24]["color_intensity"].length) {
      filterArray[24]["color_intensity"].map(function (color) {
        $(
          ".filter-diamond-intensity .filter__item[data-value=" + color + "]"
        ).addClass("active");
      });
    }
  } catch (e) {
    console.log(e.message);
  }
  // override default/stored diamond carat filter for luxe setting products
  var luxe_setting_flag = localStorage.getItem("luxe-setting-flag");
  try {
    if (
      ring_settings.tags.indexOf("luxury-engagement-rings") > -1 &&
      luxe_setting_flag
    ) {
      filterArray[8]["carat"] = `2.5,20`;
    }
  } catch (e) {
    console.log(e);
  }
  // override default/stored diamond carat filter for the reserve product
  var product_carat_range = localStorage.getItem("product-carat-range");
  try {
    if (ring_settings.tags.indexOf("the-reserve") > -1 && product_carat_range) {
      filterArray[8]["carat"] = `${product_carat_range.split("-")[0]},${
        product_carat_range.split("-")[1]
      }`;
    }
  } catch (e) {
    console.log(e);
  }

  /********************* store diamond filter settings for user *********************/
  function store_default_diamond_filter() {
    if (windowLocation.indexOf("natural-diamonds") > -1) {
      localStorage.setItem(
        "naturalDiamondFilterSetting",
        JSON.stringify(filterArray)
      );
    }
    if (windowLocation.indexOf("lab-grown-diamonds-featured-deals") > -1) {
      localStorage.setItem(
        "labFeaturedFilterSetting",
        JSON.stringify(filterArray)
      );
    } else if (
      windowLocation.indexOf("lab-diamonds") > -1 ||
      windowLocation.indexOf("lab-grown-diamonds") > -1
    ) {
      localStorage.setItem(
        "labDiamondFilterSetting",
        JSON.stringify(filterArray)
      );
    }
    if (windowLocation.indexOf("color-diamonds") > -1) {
      localStorage.setItem(
        "colorLabDiamondFilterSetting",
        JSON.stringify(filterArray)
      );
    }
    localStorage.removeItem("luxe-setting-flag");
  }
  /*==== current filter settings ===*/
  function current_filter_setting(
    filter_array_place,
    filter_array_name,
    filter_array_type
  ) {
    if (filter_array_type == "text") {
      return filterArray[filter_array_place][filter_array_name].split(",");
    } else {
      var current_fitler = filterArray[filter_array_place][filter_array_name];
      return [current_fitler[0], current_fitler[current_fitler.length - 1] + 1];
    }
  }
  /*================== Diamond Filter slider settings ===================*/
  function update_min_max_attribute(
    start_input,
    start_val,
    end_input,
    end_val,
    min = 0,
    max = 0
  ) {
    start_input.attr("data-value", start_val);
    end_input.attr("data-value", end_val);
    if (min) {
      start_input.attr("data-min", min);
    }
    if (max) {
      end_input.attr("data-max", max);
    }
  }

  function updateFilterSettings(filterName, filterValue) {
    var currentUrl = window.location.href.split("?")[0];
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has(filterName)) {
      urlParams.set(filterName, filterValue);
    } else {
      urlParams.append(filterName, filterValue);
    }
    var newUrl = currentUrl + "?" + urlParams.toString();
    history.pushState(null, "", newUrl);
  }

  function filterArraySplit(filterArray) {
    // updateFilterSettings();
    var caratValue = filterArray[8]["carat"];
    var sortOrder = filterArray[10]["orderBy"];
    var sortValue = filterArray[11]["sortBy"];
    if (caratValue) {
      updateFilterSettings("carat", caratValue);
    }
    if (sortOrder) {
      updateFilterSettings("sortBy", sortOrder);
    }
    if (sortValue) {
      updateFilterSettings("sortValue", sortValue);
    }
  }

  // Code to update diamond filter on slider value change
  function diamond_reload_on_filter_change() {
    page_count = 1;
    if (!isResetButtonClicked) {
      loadDoc(filterArray, true);
    }
    store_default_diamond_filter(filterArray);
    filterArraySplit(filterArray);
  }

  function slide_stop_n_change_event(
    has_input,
    start_input,
    end_input,
    filter_array_place,
    filter_array_name,
    filter_array_type,
    handle,
    value1,
    value2
  ) {
    if (filter_array_type == "array") {
      var number_array = [];
      for (var i = value1; i < value2; i++) {
        number_array.push(Math.round(i));
      }
      filterArray[filter_array_place][filter_array_name] = number_array;
    } else {
      filterArray[filter_array_place][filter_array_name] =
        value1 + "," + value2;
    }
    if (has_input) {
      update_min_max_attribute(start_input, value1, end_input, value2);
    }
    diamond_reload_on_filter_change();
  }

  // Initialize range slider on load
  function diamond_range_slider(
    selector,
    min,
    max,
    step,
    has_input,
    start_input,
    end_input,
    filter_array_place,
    filter_array_name,
    filter_array_type
  ) {
    var array_value = current_filter_setting(
      filter_array_place,
      filter_array_name,
      filter_array_type
    );
    if (filter_array_name === "price") {
      noUiSlider.create(selector, {
        start: [array_value[0], array_value[1]],
        connect: true,
        range: {
          min: [min, 1],
          "30%": [2000, 100],
          "70%": [10000, 500],
          "90%": [50000, 1000],
          max: [max],
        },
      });
    } else if (filter_array_name === "carat") {
      noUiSlider.create(selector, {
        start: [array_value[0], array_value[1]],
        connect: true,
        range: {
          min: [min, 0.01],
          "40%": [1, 0.05],
          "80%": [10, 0.5],
          max: [max],
        },
      });
    } else {
      if (windowLocation.indexOf("clarity-plus-diamonds") > -1) {
        noUiSlider.create(selector, {
          start: [array_value[0], array_value[1]],
          connect: true,
          margin: step,
          limit: 2,
          range: { min: min, max: max },
          step: step,
        });
      } else {
        noUiSlider.create(selector, {
          start: [array_value[0], array_value[1]],
          connect: true,
          margin: step,
          range: { min: min, max: max },
          step: step,
        });
      }
    }

    // selector.slider({
    //   range: true,
    //   min: min,
    //   max: max,
    //   step: step,
    //   values: array_value,
    //   slide: function (event, ui) {
    //     if (has_input) {
    //       if (filter_array_name == "price") {
    //         start_input.val("$" + ui.values[0]);
    //         end_input.val("$" + ui.values[1]);
    //         // return false;
    //       } else if (filter_array_name == "carat") {
    //         start_input.val(ui.values[0] + " Ct.");
    //         end_input.val(ui.values[1] + " Ct.");
    //         // return false;
    //       } else {
    //         start_input.val(ui.values[0]);
    //         end_input.val(ui.values[1]);
    //       }
    //     }
    //   },
    //   change: function (event, ui) {
    //     slide_stop_n_change_event(
    //       has_input,
    //       start_input,
    //       end_input,
    //       filter_array_place,
    //       filter_array_name,
    //       filter_array_type,
    //       event,
    //       ui
    //     );
    //   },
    // });
    if (has_input) {
      selector.noUiSlider.on("update", function (values, handle) {
        if (filter_array_name === "price") {
          start_input.val("$" + Math.round(values[0]));
          end_input.val("$" + Math.round(values[1]));
          // return false;
        } else if (filter_array_name == "carat") {
          start_input.val(values[0] + " Ct.");
          end_input.val(values[1] + " Ct.");
          // return false;
        } else if (filter_array_name == "lwratio") {
          start_input.val(values[0]);
          end_input.val(values[1]);
        } else {
          start_input.val(Math.round(values[0]));
          end_input.val(Math.round(values[1]));
        }
        update_min_max_attribute(
          start_input,
          values[0],
          end_input,
          values[1],
          min,
          max
        );
      });
    }
    selector.noUiSlider.on("set", function (values, handle) {
      slide_stop_n_change_event(
        has_input,
        start_input,
        end_input,
        filter_array_place,
        filter_array_name,
        filter_array_type,
        handle,
        values[0],
        values[1]
      );
    });
  }

  // Diamond price slider
  var diamond_price_slider = $("#diamonds-price-slider")[0];
  var diamond_cut_slider = $("#diamonds-cut-slider")[0];
  var diamond_carat_slider = $("#diamonds-carat-slider")[0];
  var diamond_color_slider = $("#diamonds-color-slider")[0];
  var diamond_clarity_slider = $("#diamonds-clarity-slider")[0];
  var diamond_polish_slider = $("#diamonds-polish-slider")[0];
  var diamond_symmetry_slider = $("#diamonds-symmetry-slider")[0];
  var diamond_fluorescence_slider = $("#diamonds-fluorescence-slider")[0];
  var diamond_lw_ratio_slider = $("#diamonds-lw-ratio-slider")[0];
  var diamond_table_slider = $("#diamonds-table-slider")[0];
  var diamond_depth_slider = $("#diamonds-depth-slider")[0];
  if (diamond_price_slider) {
    diamond_range_slider(
      diamond_price_slider,
      100,
      700000,
      100,
      true,
      $("#slide-min-price"),
      $("#slide-max-price"),
      7,
      "price",
      "text"
    );
  }
  // Cut slider
  if (diamond_cut_slider) {
    diamond_range_slider(
      diamond_cut_slider,
      0,
      4,
      1,
      false,
      null,
      null,
      1,
      "cuts",
      "array"
    );
  }
  // Carat slider
  if (diamond_carat_slider) {
    diamond_range_slider(
      diamond_carat_slider,
      0.25,
      20.3,
      0.04,
      true,
      $("#slide-min-carat"),
      $("#slide-max-carat"),
      8,
      "carat",
      "text"
    );
  }
  // Color slider
  if (windowLocation.indexOf("natural-diamonds") > -1) {
    if (diamond_color_slider) {
      diamond_range_slider(
        diamond_color_slider,
        0,
        9,
        1,
        false,
        null,
        null,
        2,
        "colors",
        "array"
      );
    }
  } else {
    if (diamond_color_slider) {
      diamond_range_slider(
        diamond_color_slider,
        4,
        9,
        1,
        false,
        null,
        null,
        2,
        "colors",
        "array"
      );
    }
  }

  // Clarity slider
  if (windowLocation.indexOf("natural-diamonds") > -1) {
    if (diamond_clarity_slider) {
      diamond_range_slider(
        diamond_clarity_slider,
        0,
        9,
        1,
        false,
        null,
        null,
        3,
        "claritys",
        "array"
      );
    }
  } else {
    if (diamond_clarity_slider) {
      diamond_range_slider(
        diamond_clarity_slider,
        3,
        9,
        1,
        false,
        null,
        null,
        3,
        "claritys",
        "array"
      );
    }
  }
  // Polish slider
  if (diamond_polish_slider) {
    diamond_range_slider(
      diamond_polish_slider,
      0,
      4,
      1,
      false,
      null,
      null,
      5,
      "polish",
      "array"
    );
  }
  // Symmetry slider
  if (diamond_symmetry_slider) {
    diamond_range_slider(
      diamond_symmetry_slider,
      0,
      4,
      1,
      false,
      null,
      null,
      6,
      "symmetrys",
      "array"
    );
  }
  // Fluorescence slider
  if (diamond_fluorescence_slider) {
    diamond_range_slider(
      diamond_fluorescence_slider,
      0,
      4,
      1,
      false,
      null,
      null,
      13,
      "fluorescences",
      "array"
    );
  }
  // L/W ratio slider
  if (diamond_lw_ratio_slider) {
    diamond_range_slider(
      diamond_lw_ratio_slider,
      0.9,
      2.75,
      0.01,
      true,
      $("#slide-min-lw-ratio"),
      $("#slide-max-lw-ratio"),
      12,
      "lwratio",
      "text"
    );
  }
  // Table slider
  if (diamond_table_slider) {
    diamond_range_slider(
      diamond_table_slider,
      40,
      90,
      1,
      true,
      $("#slide-min-table"),
      $("#slide-max-table"),
      15,
      "table",
      "text"
    );
  }
  // Depth slider
  if (diamond_depth_slider) {
    diamond_range_slider(
      diamond_depth_slider,
      40,
      90,
      1,
      true,
      $("#slide-min-depth"),
      $("#slide-max-depth"),
      16,
      "depth",
      "text"
    );
  }

  loadDoc(filterArray, true);

  function reset_slider_div(store_diamond_setting, obj) {
    // remove active class from filter button
    // $(
    //   ".diamond-filter__container .filter__item,.diamond__quick-shop-tab"
    // ).removeClass("active");
    // reset diamond filter json
    filterArray = [
      { shapes: [] },
      { cuts: [0, 1, 2, 3] },
      { colors: [0, 1, 2, 3, 4, 5, 6, 7, 8] },
      { claritys: [0, 1, 2, 3, 4, 5, 6, 7, 8] },
      { labs: [] },
      { polish: [0, 1, 2, 3] },
      { symmetrys: [0, 1, 2, 3] },
      { price: "100,1000000" },
      { carat: "0.25,20" },
      { page: 1 },
      { orderBy: "Price" },
      { sortBy: "ASC" },
      { lwratio: "0.9,2.75" },
      { fluorescences: [0, 1, 2, 3] },
      { sku: "" },
      { table: "40,90" },
      { depth: "40,90" },
      { type: "" },
      { diamond_type: diamond_type },
      { cert_num: "" },
      { quick_ship_diamonds: "N" },
      { Appointment: "" },
      { VaultDiscount: "No" },
      { country: theme.country_iso_code },
      { reports: "" },
    ];
    if (store_diamond_setting) {
      if (windowLocation.indexOf("featured-deals") > -1) {
        filterArray[22]["VaultDiscount"] = "Yes";
        $(".filter-featured-deals .text-box").addClass("active"); // featured diamond filter for mobile
        $(".diamond__featured-deal").addClass("quick-active"); // featured diamond filter for desktop
        store_default_diamond_filter(filterArray);
        diamond_reload_on_filter_change();
        return false;
      } else {
        store_default_diamond_filter(filterArray);
        diamond_reload_on_filter_change();
        return false;
      }
    }
    if (obj.cert_num && obj.cert_num.length > 0) {
      filterArray[19]["cert_num"] = obj.cert_num;
      diamond_reload_on_filter_change();
      return false;
    }
    if (obj.sku && obj.sku.length > 0) {
      filterArray[14]["sku"] = obj.sku;
      diamond_reload_on_filter_change();
      return false;
    }
  }

  // reset range slider on click on "Reset filter" button
  function reset_range_slider() {
    diamond_price_slider.noUiSlider.set([100, null]); // code to set 1 value to 100
    diamond_price_slider.noUiSlider.set([null, 700000]); // code to set 2 value to 1000000
    $("#slide-min-price").val("$" + 100);
    $("#slide-max-price").val("$" + 1000000);
    diamond_cut_slider.noUiSlider.set([0, null]);
    diamond_cut_slider.noUiSlider.set([null, 5]);
    diamond_carat_slider.noUiSlider.set([0.25, null]);
    diamond_carat_slider.noUiSlider.set([null, 20.3]);
    $("#slide-min-carat").val(0.25 + " Ct.");
    $("#slide-max-carat").val(20.3 + " Ct.");
    diamond_color_slider.noUiSlider.set([0, null]);
    diamond_color_slider.noUiSlider.set([null, 9]);
    diamond_clarity_slider.noUiSlider.set([0, null]);
    diamond_clarity_slider.noUiSlider.set([null, 9]);
    diamond_polish_slider.noUiSlider.set([0, null]);
    diamond_polish_slider.noUiSlider.set([null, 4]);
    diamond_symmetry_slider.noUiSlider.set([0, null]);
    diamond_symmetry_slider.noUiSlider.set([null, 4]);
    diamond_fluorescence_slider.noUiSlider.set([0, null]);
    diamond_fluorescence_slider.noUiSlider.set([null, 4]);
    diamond_lw_ratio_slider.noUiSlider.set([0.9, null]);
    diamond_lw_ratio_slider.noUiSlider.set([null, 2.75]);
    diamond_table_slider.noUiSlider.set([40, null]);
    diamond_table_slider.noUiSlider.set([null, 90]);
    diamond_depth_slider.noUiSlider.set([40, null]);
    diamond_depth_slider.noUiSlider.set([null, 90]);
  }

  // Reset filters
  $(".reset-diamond-filter").on("click", function () {
    $(".diamond__gcal-tab").removeClass("active");
    $(".diamond__quick-shop-tab,.diamond__featured-deal").removeClass(
      "quick-active"
    );
    $(".filter-shapes .shape").removeClass("active");
    removeFeatureFlagFromUrl();
    reset_slider_div(true);
    isResetButtonClicked = true;
    reset_range_slider();
  });

  // Search diamond with certificate number
  function api_to_certificate_serach(cert_num) {
    var jsonData = {
      filter: [{ diamond_id: cert_num }],
    };
    $(".diamond-body").html("");
    $(".diamonds-list .loader,.loader-2").show();
    $("#diamond-count,#diamond-total-count").hide();
    axios
      .post(`${server_closure}/fetchparticulardiamonddetail/`, jsonData)
      .then((res) => {
        var diamond_info = res.data.data.liveDiamondData.diamond[0];
        // return diamond_info;
        updateDiamondCount(1, 1);
        if (diamond_info) {
          var diamond_html = diamond_listing_html(diamond_info);
          $("#diamond-count,.diamond__all-diamond-tab span").text(1);
          $(".diamond-body").html(diamond_html);
        } else {
          $("#diamond-count,.diamond__all-diamond-tab span").text(0);
          $(".diamond-body").html(
            `<p class="empty-diamond">No Diamonds Found.</p>`
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  $(".diamond-certificate-serach button").on("click", function () {
    var cert_num = $(this)
      .closest(".diamond-certificate-serach")
      .find("input")
      .val();
    api_to_certificate_serach(cert_num);
    // reset_slider_div(false, { cert_num });
  });
  // Search diamond with sku number
  $(".diamond-sku-serach button").on("click", function () {
    var sku = $(this).closest(".diamond-sku-serach").find("input").val();
    reset_slider_div(false, { sku });
  });

  // Change range slider value on change of respective input value
  $(".slider-value-wrapper input").on("click", function () {
    $(this).val("");
  });

  // function called when valid input value passed to range slider input field
  function refresh_range_slider(
    range_slider_id,
    min,
    max,
    slider_start_value,
    slider_end_value
  ) {
    $d("#" + range_slider_id)[0].noUiSlider.set([min, null]);
    $d("#" + range_slider_id)[0].noUiSlider.set([null, max]);
    // function is used to update min and max
    update_min_max_attribute(slider_start_value, min, slider_end_value, max);
  }

  // function called when input value changed/Focused
  function change_slider_input_val(
    input_prefix,
    input_suffix,
    input_field,
    input_value
  ) {
    if (input_prefix.length) {
      input_field.val(input_prefix + input_value);
    } else if (input_suffix.length) {
      input_field.val(input_value + input_suffix);
    } else {
      input_field.val(input_value);
    }
  }

  // Code to trigger range slider on range slider input value change
  $(".slider-value-wrapper input").on("focusout", function () {
    var closest_slider_parent = $(this).closest(".filter-with-input-value");
    var slider_start_value = closest_slider_parent.find(".slider-start-value");
    var slider_end_value = closest_slider_parent.find(".slider-end-value");
    var range_slider_title = closest_slider_parent
      .find("h3")
      .text()
      .split("By ")[1];
    var range_slider_id = closest_slider_parent
      .find(".range-slider")
      .attr("id");
    var range_slider_type = closest_slider_parent.attr("id");
    var value = parseFloat($(this).val()) || 0;
    var min_start_value = parseFloat(slider_start_value.attr("data-min"));
    var max_end_value = parseFloat(slider_end_value.attr("data-max"));
    var past_start_value = parseFloat(slider_start_value.attr("data-value"));
    var past_end_value = parseFloat(slider_end_value.attr("data-value"));

    // input prefix($) and input suffix(Ct.) for price and carat range slider respectively
    let input_suffix = "";
    let input_prefix = "";
    if (range_slider_type.indexOf("filter__price") > -1) {
      input_prefix = "$";
    }
    if (range_slider_type.indexOf("filter__carat") > -1) {
      input_suffix = " Ct.";
    }
    var is_start_value = $(this).hasClass("slider-start-value");
    let start_value = closest_slider_parent.find(".slider-start-value").val();
    let end_value = closest_slider_parent.find(".slider-end-value").val();
    if (input_prefix.length) {
      start_value = start_value.replace("$", "");
      end_value = end_value.replace("$", "");
    } else if (input_prefix.length) {
      start_value = start_value.replace(" Ct.", "");
      end_value = end_value.replace(" Ct.", "");
    }
    start_value = parseFloat(start_value);
    end_value = parseFloat(end_value);
    if (is_start_value) {
      if (value > end_value) {
        alert(
          `${
            range_slider_title.substr(0, 1).toUpperCase() +
            range_slider_title.substr(1)
          } Min value should be less than ${range_slider_title} max value`
        );
        change_slider_input_val(
          input_prefix,
          input_suffix,
          slider_start_value,
          past_start_value
        );
        // slider_start_value.val(past_start_value);
      } else if (value < min_start_value) {
        alert(
          `${
            range_slider_title.substr(0, 1).toUpperCase() +
            range_slider_title.substr(1)
          } Min value should be greater than or equal to ${min_start_value}`
        );
        change_slider_input_val(
          input_prefix,
          input_suffix,
          slider_start_value,
          past_start_value
        );
        // slider_start_value.val(past_start_value);
      } else {
        change_slider_input_val(
          input_prefix,
          input_suffix,
          slider_start_value,
          value
        );
        refresh_range_slider(
          range_slider_id,
          value,
          end_value,
          slider_start_value,
          slider_end_value
        );
      }
    } else {
      if (value < start_value) {
        alert(
          `${
            range_slider_title.substr(0, 1).toUpperCase() +
            range_slider_title.substr(1)
          } Max value should be greater than ${range_slider_title} Min value`
        );
        change_slider_input_val(
          input_prefix,
          input_suffix,
          slider_end_value,
          past_end_value
        );
        // slider_end_value.val(past_end_value);
      } else if (value > max_end_value) {
        alert(
          `${
            range_slider_title.substr(0, 1).toUpperCase() +
            range_slider_title.substr(1)
          } Max value should be less than or equal to ${max_end_value}`
        );
        change_slider_input_val(
          input_prefix,
          input_suffix,
          slider_end_value,
          past_end_value
        );
        // slider_end_value.val(past_end_value);
      } else {
        change_slider_input_val(
          input_prefix,
          input_suffix,
          slider_end_value,
          value
        );
        refresh_range_slider(
          range_slider_id,
          start_value,
          value,
          slider_start_value,
          slider_end_value
        );
      }
    }
  });

  // code to filter by shape
  $(".filter-shapes .shape").on("click", function () {
    filterArray[0].shapes = [];
    // $("#filter__shape").addClass("disabled");
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this).addClass("active");
    }
    $(".filter-shapes .shape.active").each(function () {
      filterArray[0].shapes.push($(this).data("value"));
    });
    // check if ring settings is selected
    if (ring_settings && filterArray[0].shapes.length < 1) {
      filterArray[0].shapes.push(ring_settings.shape);
      $(
        '.filter-shapes .shape[data-value="' + ring_settings.shape + '"]'
      ).addClass("active");
    }
    store_default_diamond_filter();
    diamond_reload_on_filter_change();
  });

  // code to filter by color for color diamond collection
  $(".filter-diamond-colors .color").on("click", function () {
    filterArray[2].colors = [];
    var data_value = $(this).data("value");
    $("#filter__color").addClass("disabled");
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(".filter-diamond-intensity").attr("data-color", "");
      $('.filter__diamond-intensity').hide();
    } else {
      $(".filter-diamond-colors .color").removeClass("active");
      $(this).addClass("active");
      $(".filter-diamond-intensity").attr("data-color", data_value);
      $('.filter__diamond-intensity').show();
    }
    $(".filter-diamond-colors .color.active").each(function () {
      filterArray[2].colors.push(data_value);
    });
    store_default_diamond_filter();
    diamond_reload_on_filter_change();
  });

  // code to filter by intensity for color diamond collection
  $(".filter-diamond-intensity .filter__item").on("click", function () {
    filterArray[24].color_intensity = [];
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this).addClass("active");
    }
    $(".filter-diamond-intensity .filter__item.active").each(function () {
      var data_value = $(this).data("value");
      filterArray[24].color_intensity.push(data_value);
    });
    store_default_diamond_filter();
    diamond_reload_on_filter_change();
  });

  // code to filter by featured deals
  $(".filter-featured-deals .text-box").on("click", function () {
    if (windowLocation.indexOf("diamonds-featured-deals") > -1) {
      return false;
    }
    removeFeatureFlagFromUrl();
    if ($(this).hasClass("active")) {
      $(".diamond__featured-deal").removeClass("quick-active");
      $(this).removeClass("active");
      filterArray[22]["VaultDiscount"] = "No";
    } else {
      $(this).addClass("active");
      $(".diamond__featured-deal").addClass("quick-active");
      filterArray[22]["VaultDiscount"] = "Yes";
    }
    store_default_diamond_filter();
    diamond_reload_on_filter_change();
  });
  // code to filter by Report
  $(".filter-report .text-box").on("click", function () {
    filterArray[4].labs = [];
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this).addClass("active");
    }
    var report = "";
    $(".diamond__gcal-tab").removeClass("active");
    $(".filter-report .text-box.active").each(function () {
      if ($(this).data("value") == "GCAL") {
        $(".diamond__gcal-tab").addClass("active");
      }
      filterArray[4].labs.push($(this).data("value"));
    });
    diamond_reload_on_filter_change();
  });

  // code to filter by True Clarity diamond
  $(".diamond__gcal-tab").on("click", function () {
    filterArray[4].labs = [];
    var hasActiveClass = $(this).hasClass("active");
    if (hasActiveClass) {
      $(this).removeClass("active");
      $(".filter-report [data-value='GCAL']").removeClass("active");
    } else {
      $(this).addClass("active");
      $(".filter-report [data-value='GCAL']").addClass("active");
    }
    $(".filter-report .text-box.active").each(function () {
      filterArray[4].labs.push($(this).data("value"));
    });
    // diamond_reload_on_filter_change();
    // $(".diamond__tab-wrapper .tab-box").removeClass("active");
    // $(".diamond__tab-wrapper .diamond__all-diamond-tab").addClass("active");
    $(".diamond-body").show();
    $(".diamond-compare-body").hide();
    store_default_diamond_filter();
    diamond_reload_on_filter_change();
  });

  // code to filter by quickship diamond
  // $(".diamond__quick-shop-tab").on("click", function () {
  //   var hasActiveClass = $(this).hasClass("quick-active");
  //   if (hasActiveClass) {
  //     $(this).removeClass("quick-active");
  //     filterArray[20]["quick_ship_diamonds"] = "N";
  //   } else {
  //     $(this).addClass("quick-active");
  //     filterArray[20]["quick_ship_diamonds"] = "Y";
  //   }
  //   $(".diamond__tab-wrapper .diamond__quick-shop-tab").removeClass("active");
  //   $(".diamond__tab-wrapper .diamond__all-diamond-tab").addClass("active");
  //   $(".diamond-body").show();
  //   $(".diamond-compare-body").hide();
  //   store_default_diamond_filter();
  //   diamond_reload_on_filter_change();
  // });

  // Update localstorage compare diamond count
  function compare_diamond_count(stored_certificates_array) {
    $(".diamond__compare-diamond-tab span").text(
      stored_certificates_array.length
    );
  }
  compare_diamond_count(compare_diamond);
  // Load compare diamond listing
  function load_compare_diamond() {
    var render_html_data = "";
    var stored_certificates_obj =
      JSON.parse(sessionStorage.getItem("compare_certificate_obj")) || {};
    $.each(stored_certificates_obj, function (key, value) {
      render_html_data += diamond_listing_html(value);
    });
    if (render_html_data.length > 100) {
      $(".diamond-compare-body").html(render_html_data);
    } else {
      $(".diamond-compare-body").html(
        `<p class="empty-diamond">Please select diamond to compare.</p>`
      );
    }
  }
  // Add certificate number to array and object compare
  $(document).on("click", ".diamond-list .diamond-compare", function () {
    var hasActiveClass = $(this).hasClass("active");
    var diamond_data = $(this).closest(".diamond-list").data("diamond-json");
    // let stored_certificates_array =
    //   JSON.parse(sessionStorage.getItem("compareCertificatesList")) || [];
    var stored_certificates_obj =
      JSON.parse(sessionStorage.getItem("compare_certificate_obj")) || {};

    if (hasActiveClass) {
      var indexNumber = compare_diamond.indexOf(diamond_data["cert_num"]);
      compare_diamond.splice(indexNumber, 1);
      delete stored_certificates_obj[diamond_data["cert_num"]];
      $(this).removeClass("active");
    } else {
      $(this).addClass("active");
      compare_diamond.push(diamond_data["cert_num"]);
      stored_certificates_obj[diamond_data["cert_num"]] = diamond_data;
    }
    sessionStorage.setItem(
      "compareCertificatesList",
      JSON.stringify(compare_diamond)
    );
    sessionStorage.setItem(
      "compare_certificate_obj",
      JSON.stringify(stored_certificates_obj)
    );
    compare_diamond_count(compare_diamond);
    load_compare_diamond();
  });

  // save diamond in cookies and redirect to diamond product page
  $(document).on("click", ".diamonds-list-container a", function (e) {
    // e.preventDefault();
    let diamond_pdp_obj = theme.get_local_storage("diamond-pdp-obj");
    if (diamond_pdp_obj) {
      diamond_pdp_obj = JSON.parse(diamond_pdp_obj);
    } else {
      diamond_pdp_obj = {};
    }
    var diamond_json_data = $(this)
      .closest(".diamond-list")
      .data("diamond-json");
    // push diamond information in session object
    diamond_pdp_obj[diamond_json_data.cert_num] = diamond_json_data;
    theme.set_local_storage("diamond-pdp-obj", JSON.stringify(diamond_pdp_obj));
    // window.location.href =
    //   theme.diamond_product_url + "/" + diamond_json_data?.cert_num;
  });

  // Tab switch code
  $(".diamond__compare-diamond-tab").on("click", function () {
    // $(this)
    //   .closest(".diamond__tab-wrapper")
    //   .find(".tab-box")
    //   .removeClass("active");
    var tab_type = $(this).data("tab-type");
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(".diamond-body").show();
      $("." + tab_type).hide();
    } else {
      $(this).addClass("active");
      $(".diamond-body").hide();
      $("." + tab_type).show();
      load_compare_diamond();
    }
  });
  // functionlity to sort the diamond on click on diamond header or sort by change
  // "is_page_refresh" variable is created to prevent diamond ajax call
  function apply_sorting_on_diamond(
    _this,
    sort_name,
    sort_type,
    is_page_refresh = false
  ) {
    var addClass = sort_type == "ASC" ? "sort-order-asc" : "sort-order-desc";
    var removeClass = sort_type == "ASC" ? "sort-order-desc" : "sort-order-asc";
    filterArray[10]["orderBy"] = sort_name;
    filterArray[11]["sortBy"] = sort_type;
    _this.removeClass(removeClass);
    _this.addClass(`active ${addClass}`);
    if (!is_page_refresh) {
      diamond_reload_on_filter_change();
    }
  }
  $(".diamond-heading .sort-wrapper").on("click", function (e) {
    var sort_name = $(this).data("type");
    $(
      ".diamond-heading .sort-wrapper:not([data-type=" + sort_name + "])"
    ).removeClass("active sort-order-asc sort-order-desc");
    var sort_type = $(this).hasClass("sort-order-asc") ? "DESC" : "ASC";
    apply_sorting_on_diamond($(this), sort_name, sort_type);
  });
  // on load add filter value to diamond heading
  var load_sort_name = filterArray[10]["orderBy"];
  var load_sort_type = filterArray[11]["sortBy"];
  var load_filter_selector = $(
    `.diamond-heading .sort-wrapper[data-type='${load_sort_name}']`
  );
  apply_sorting_on_diamond(
    load_filter_selector,
    load_sort_name,
    load_sort_type,
    true
  );
  // Custom select dropdown for sort by function
  $(".select-dropdown__button").on("click", function () {
    $(this)
      .closest(".select-dropdown")
      .find(".select-dropdown__list")
      .toggleClass("active");
  });
  $(".diamond__sort-list .select-dropdown__list-item").on("click", function () {
    var itemValue = $(this).data("value");
    $(".select-dropdown__list-item").removeClass("active-dropdown");
    $(this).addClass("active-dropdown");
    $(".diamond__sort-list .sort_by-title").text($(this).text());
    $(".diamond__sort-list .select-dropdown__list").toggleClass("active");
    var sort_name = itemValue.split("-")[0];
    var sort_type = itemValue.split("-")[1];
    $(
      ".diamond-heading .sort-wrapper:not([data-type=" + sort_name + "])"
    ).removeClass("active sort-order-asc sort-order-desc");
    var _this = $(".sort-wrapper[data-type=" + sort_name + "]");
    apply_sorting_on_diamond(_this, sort_name, sort_type);
  });
  // on load add filter value to sort by dropdown
  var sort_by_title_selector = $(".select-dropdown__button .sort_by-title");
  var sort_by_title = $(
    `.select-dropdown__list [data-value=${load_sort_name}-${load_sort_type}]`
  ).text();
  $(
    `.select-dropdown__list [data-value=${load_sort_name}-${load_sort_type}]`
  ).addClass("active-dropdown");
  sort_by_title_selector.text(sort_by_title);

  // Custom select dropdown for report
  $(".report-dropdown__button").on("click", function () {
    $(this)
      .closest(".select-dropdown")
      .find(".select-dropdown__list")
      .toggleClass("active");
  });
  $(".diamond__report-list .select-dropdown__list-item").on(
    "click",
    function () {
      var itemValue = $(this).data("value");
      $(".diamond__report-list .select-dropdown__list-item").removeClass(
        "active-dropdown"
      );
      $(this).addClass("active-dropdown");
      $(".diamond__report-list .sort_by-title").text($(this).text());
      $(".diamond__report-list .select-dropdown__list").toggleClass("active");
      filterArray[4].labs = [];
      filterArray[4].labs.push(itemValue);
      diamond_reload_on_filter_change();
    }
  );
  $(".diamond__featured-deal").on("click", function () {
    $(".filter-featured-deals .text-box").trigger("click");
  });
  // $("#diamond__sort-by").on("change", function (e) {
  //   var value = $(this).val();
  //   var sort_name = value.split("-")[0];
  //   var sort_type = value.split("-")[1];
  //   $(
  //     ".diamond-heading .sort-wrapper:not([data-type=" + sort_name + "])"
  //   ).removeClass("active sort-order-asc sort-order-desc");
  //   var _this = $(".sort-wrapper[data-type=" + sort_name + "]");
  //   apply_sorting_on_diamond(_this, sort_name, sort_type);
  // });

  // Load data on scroll
  // for mobile
  $(document).on("touchmove", onScroll);
  // for desktop
  $(window).scroll(function () {
    onScroll();
  });
  function onScroll() {
    var position = $(window).scrollTop();
    var bottom = $(document).height() - $(window).height() - 2300;
    if (position >= bottom) {
      fetchData();
    }
  }

  function checkWindowSize() {
    if ($(window).height() >= $(document).height()) {
      fetchData();
    }
  }
  checkWindowSize();
  // Fetch records
  var is_diamond_body_visible = $(".diamond-body");
  function fetchData() {
    if (
      diamond_loading &&
      diamond_count < total_diamond_count &&
      is_diamond_body_visible.is(":visible")
    ) {
      diamond_loading = false;
      loadDoc(filterArray);
    }
  }
  // diamond tab page change
  $(".diamond-tab").on("click", function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      return false;
    }
    var diamond_tab_type = $(this).data("diamond");
    var is_featured_fitler = $(".filter-featured-deals .filter__item").hasClass(
      "active"
    );
    // 'is_featured_fitler' is used to check if featured diamond filter is active, if active then redirect to show featured diamond only
    if (is_featured_fitler && diamond_tab_type != "color-diamonds") {
      window.location.href = `/collections/${diamond_tab_type}?feature=true`;
    } else {
      window.location.href = `/collections/${diamond_tab_type}`;
    }
  });
  // show/hide addional diamond filters
  if ($(window).width() > 749) {
    var show_hide_click_count = 0;
    $(".show-hide-advance-filter").on("click", function (e) {
      if (show_hide_click_count % 2 == 0) {
        $(this).text("Hide Advanced");
      } else {
        $(this).text("Show Advance");
      }
      e.preventDefault();
      $(".advance-filter-container").slideToggle();
      $(".diamond-heading,.diamond-body,.diamond-compare-body").toggleClass(
        "active"
      );
      show_hide_click_count += 1;
    });
  }
});
